import PropTypes from 'prop-types';
import Alert from '@material-ui/lab/Alert';
import {
  Box,
  CircularProgress,
  DialogContent as MuiDialogContent,
  Grid,
  Typography,
} from '@material-ui/core';
import { DIALOG_STEP, SEND_TO_EMAIL, SEND_TO_SMS } from '../consts';
import { getDeliveryEligibility } from '../getDeliveryEligibility';
import DeliveryMethod from './DeliveryMethod';
import Digits from './Digits';
import Info from './Info';
import Reasons from './Reasons';

const noop = () => null;

const DialogContent = ({
  fspId,
  fspOtpConfig,
  isSendBusy,
  onChange,
  onSendToChange,
  payerId,
  sendTo,
  step,
  stepError,
  userId,
  userInfo,
}) => {
  const deliveryEligibility = getDeliveryEligibility(userInfo, fspOtpConfig);

  return (
    <MuiDialogContent>
      {step === DIALOG_STEP.CONFIGURE && (
        <>
          {stepError && (
            <Alert severity="error" style={{ marginBottom: 16 }}>
              {stepError}
            </Alert>
          )}
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <Info fspId={fspId} payerId={payerId} userId={userId} />
            </Grid>
            <Grid item>
              <Reasons onChange={onChange} payerId={payerId} />
            </Grid>
            <Grid item>
              <Digits fspId={fspId} payerId={payerId} />
            </Grid>
          </Grid>
        </>
      )}
      {step === DIALOG_STEP.DELIVERY && (
        <>
          {isSendBusy && (
            <Box alignItems="center" display="flex" mb={1.5}>
              <CircularProgress size={20} style={{ marginRight: 8 }} />
              <Typography variant="body2">
                {sendTo === SEND_TO_EMAIL
                  ? 'Sending OTP via email...'
                  : 'Sending OTP via SMS...'}
              </Typography>
            </Box>
          )}
          {stepError && (
            <Alert severity="error" style={{ marginBottom: 8 }}>
              {stepError}
            </Alert>
          )}
          <DeliveryMethod
            canSendEmail={deliveryEligibility.canSendEmail}
            canSendSms={deliveryEligibility.canSendSms}
            onSendToChange={onSendToChange}
            sendTo={sendTo}
            userInfo={userInfo}
          />
        </>
      )}
    </MuiDialogContent>
  );
};

DialogContent.propTypes = {
  fspId: PropTypes.number.isRequired,
  fspOtpConfig: PropTypes.object,
  isSendBusy: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onSendToChange: PropTypes.func,
  payerId: PropTypes.number.isRequired,
  sendTo: PropTypes.string,
  step: PropTypes.oneOf(Object.values(DIALOG_STEP)),
  stepError: PropTypes.string,
  userId: PropTypes.number.isRequired,
  userInfo: PropTypes.object,
};

DialogContent.defaultProps = {
  fspOtpConfig: null,
  isSendBusy: false,
  onSendToChange: noop,
  sendTo: SEND_TO_SMS,
  step: DIALOG_STEP.CONFIGURE,
  stepError: null,
  userInfo: null,
};

export default DialogContent;
